<template>
  <div class="button-container">
    <button 
      class="gsap-button"
      @mouseenter="handleMouseEnter"
      @mouseleave="handleMouseLeave"
      @mousemove="handleMouseMove"  
      ref="button"
    >
      <slot></slot> <!-- 插槽，用于按钮内部内容 -->
    </button>
  </div>
</template>

<script>
import { gsap } from "gsap";

export default {
  name: "GsapButton",
  data() {
    return {
      enterAngle: 0, // 用来存储鼠标进入时的角度
    };
  },
  computed: {
   
  },
  methods: {
    handleMouseEnter(event) {
      const button = this.$refs.button;
      const rect = button.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;
      const width = button.offsetWidth;
      const height = button.offsetHeight;

      // 计算鼠标进入按钮时的角度
      const angle = Math.atan2(y - height / 2, x - width / 2);
      this.enterAngle = (angle + Math.PI) / (2 * Math.PI); // 将角度转化为 0-1 的值

      // 将角度转换为 360 度，并使用 GSAP 动画填充颜色
      const angleDeg = this.enterAngle * 360;

      // 鼠标移入时，背景开始填充
      gsap.to(button, {
        background: `linear-gradient(${angleDeg}deg, #55A5FA, #55A5FA)`, // 根据鼠标角度动态填充背景
        duration: 1.2,
        ease: "power2.out",
        backgroundSize: "200% 200%", // 扩大背景区域，模拟填充效果
        scaleX: 1.1, // 按钮的缩放，增强效果
        scaleY: 1.1, // 按钮的缩放，增强效果
    
      });

      this.isMouseEntered = true; // 标记鼠标已进入
    },

    handleMouseMove(event) {
      if (!this.isMouseEntered) return; // 只有在鼠标进入时才进行处理

      const button = this.$refs.button;
      const rect = button.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;
      const width = button.offsetWidth;
      const height = button.offsetHeight;

      // 计算鼠标在按钮内移动时的角度
      const angle = Math.atan2(y - height / 2, x - width / 2);
      const normalizedAngle = (angle + Math.PI) / (2 * Math.PI); // 转换为 0 到 1 之间的值
      const angleDeg = normalizedAngle * 360; // 将角度转换为 360 度

      // 使用 GSAP 动画平滑更新背景渐变的方向
      gsap.to(button, {
        background: `linear-gradient(${angleDeg}deg, white, #55A5FA)`, // 根据鼠标的角度动态调整背景
        duration: 1.2, // 动画持续时间，快速响应
        ease: "power2.out",
      });
    },

    handleMouseLeave() {
      const button = this.$refs.button;

      // 鼠标离开时，背景颜色沿着原来的路径平滑收回
      gsap.to(button, {
        background: `linear-gradient(${this.enterAngle * 360}deg, white, white)`, // 沿着进入时的角度退出
        backgroundSize: "100% 100%", // 恢复背景大小
        duration: 1.2,
        ease: "power2.out",
        scaleX: 1, // 恢复原始大小
        scaleY: 1, // 恢复原始大小
      });

      this.isMouseEntered = false; // 标记鼠标已离开
    },
  }
};
</script>
  
  <style scoped>
  .gsap-button {
  width: 120px;
  height: 36px;
  background: white; 
  border-radius: 2px;
  border: 2px solid transparent; 
  margin-left: 20px;
  color: #55A5FA; 
  border: none;
  cursor: pointer; 
  
  transition: background-color 0.3s ease, transform 0.3s ease;
}

.gsap-button:focus {
  outline: none;
}
  </style>
  